import clsx from 'clsx'
import { Icon } from '@iconify/react'

import { Tooltip } from '@pepper/ui'
import TrendsChart from 'container/SEOTools/components/TrendsChart/TrendsChart'
import { formatLongNumber } from 'utils/functions/formatLongNumber'

import s from './TrafficStat.module.css'

import type { GapReport, GapReportDocument } from '@pepper/utils/src/types/seo'

type Props = {
  document: GapReportDocument['document']
  report: GapReport
}

const TrafficStat = ({ document, report }: Props) => {
  return (
    <div className={s.trafficWrapper}>
      <div className={s.left}>
        <div className={s.top}>
          <p className={s.title}>Current Organic Traffic</p>
          <Tooltip title="Stay on top of your search game with real-time updates on your current traffic and top keywords.">
            <Icon
              icon="lucide:info"
              className={s.icon}
              width={16}
              height={16}
            />
          </Tooltip>
        </div>
        <div className={s.bottom}>
          <h4 className={s.largeValue}>
            {formatLongNumber(report?.traffic ?? 0, 1)}
          </h4>
          <div className={s.chart}>
            <TrendsChart trends={document?.target_keyword_stats.trends} />
          </div>
        </div>
      </div>
      <div className={clsx(s.right)}>
        <div className={s.top}>
          <p className={clsx(s.title, s.greenText)}>Potential Traffic</p>
          <Tooltip
            placement="left"
            title="Unlock your full search potential with estimated traffic and keywords in top 10."
          >
            <Icon
              icon="lucide:info"
              className={clsx(s.icon, s.greenText)}
              width={16}
              height={16}
            />
          </Tooltip>
        </div>
        <div className={s.bottom}>
          <h4 className={s.greenLarge}>
            {formatLongNumber(report?.potential_traffic ?? 0, 1)}
          </h4>
        </div>
      </div>
    </div>
  )
}

export default TrafficStat
